export default {
  /**是否开发模式 */
  isDebug: () => {
    return "development" === process.env.NODE_ENV;
  },
  /**是否登录 */
  isLogin: state => {
    return state.token != null;
  },
  /**重定向路由 */
  getRedictRouter: state => {
    var path = state.token != null ? null : { path: "/login" };
    if (state.role && state.redictRouter) {
      path = state.redictRouter;
    }
    return path;
  },
  dict: state => state.dict,
  dictAll: state => state.dictAll
};
